import UploadedImagesContext from '@/components/FileAttachments/UploadedImagesContext';
import RubricsPortfolioContext from '@/lib/contexts/RubricsPortfolioContext';
import { type UploadedImage } from '@/lib/types';
import { type WritableDraft } from 'immer';
import { useContext } from 'react';
import type React from 'react';
import useRubricsPortfolioApiEndpoint from '../../../useRubricsPortfolioApiEndpoint';

type ProofImagesContextProviderProps = {
  levelId: number;
  children: React.ReactNode;
};

const ProofImagesContextProvider = ({
  levelId,
  children,
}: ProofImagesContextProviderProps) => {
  const rubricsPortfolioApiEndpoint = useRubricsPortfolioApiEndpoint();

  const [portfolio, setPortfolio] = useContext(RubricsPortfolioContext);
  const proofImages = Object.values(portfolio.proofImages?.[levelId] ?? {});

  return (
    <UploadedImagesContext.Provider
      value={{
        images: proofImages,
        imagesEndpoint: `${rubricsPortfolioApiEndpoint}/proof/${levelId}/images`,
        addImageToLocalState: (image: UploadedImage): void => {
          setPortfolio(portfolio => {
            if (typeof portfolio.proofImages![levelId] === 'undefined') {
              portfolio.proofImages![levelId] = {};
            }

            portfolio.proofImages![levelId][image.id] = image;
          });
        },
        updateImageInLocalState: (
          image: UploadedImage,
          stateUpdater: (image: WritableDraft<UploadedImage>) => void,
        ): void => {
          setPortfolio(portfolio => {
            stateUpdater(portfolio.proofImages![levelId][image.id]);
          });
        },
        removeImageFromLocalState: (image: UploadedImage): void => {
          setPortfolio(portfolio => {
            delete portfolio.proofImages![levelId][image.id];
          });
        },
      }}
    >
      {children}
    </UploadedImagesContext.Provider>
  );
};

export default ProofImagesContextProvider;
